import type { AppScope } from '../appScope.types';

/** Internal-only sentinel — never exposed via AppScopeService. */
export const NOT_INITIALIZED_APP_SCOPE = {
  level: 'not-initialized'
} as const;

export type NotInitializedAppScope = typeof NOT_INITIALIZED_APP_SCOPE;

/** Context value — includes bootstrap sentinel not visible to service consumers. */
export type InternalAppScope = AppScope | NotInitializedAppScope;

export function isInitializedAppScope(
  scope: InternalAppScope
): scope is AppScope {
  return scope.level !== 'not-initialized';
}

export function assertInitializedAppScope(
  scope: InternalAppScope
): asserts scope is AppScope {
  if (!isInitializedAppScope(scope)) {
    throw new Error(
      'AppScope is not initialized yet — consumer mounted before organizationId was available'
    );
  }
}
